import React, { createContext, useState } from "react";

export interface BadgeAmount {
	comments: number;
	reminders: number;
	votes: number;
	invites: number;
}

export type BadgeAmountContextType = {
	badgeAmount: BadgeAmount;
	setBadgeAmount: React.Dispatch<React.SetStateAction<BadgeAmount>>;
};

export const BadgeAmountContext = createContext<BadgeAmountContextType | null>(null);

const BadgeAmountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [badgeAmount, setBadgeAmount] = useState<BadgeAmount>({
		comments: 0,
		reminders: 0,
		votes: 0,
		invites: 0,
	});

	return (
		<BadgeAmountContext.Provider value={{ badgeAmount, setBadgeAmount }}>
			{children}
		</BadgeAmountContext.Provider>
	);
};

export default BadgeAmountProvider;
